<template>
  <div
    :class="DS_GRID_CLASSES.Item"
    data-cy="ds-grid__item"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { DS_GRID_CLASSES } from "@/src/design_system/layouts_and_containers/grid/constants/classes";
</script>
